// Formy zależne od płci dziecka w tekstach ekranów: „Skończył{eś|aś}” → wg profilu (rodzic ustawia płeć; brak = forma męska). Zob. lib/gender.ts.
import { forGender } from '../lib/gender.ts';
import type { Gender } from '../lib/gender.ts';
import type { AppCtx } from './ctx.ts';

export const genderOf = (ctx: Pick<AppCtx, 'account'>): Gender => ctx.account?.profile()?.gender ?? '';

/** Tekst z klamrami `{eś|aś}` rozwiązany dla aktywnego dziecka. */
export const say = (ctx: Pick<AppCtx, 'account'>, text: string): string => forGender(text, genderOf(ctx));
